"use client";

import { Chart as ChartJS, Legend, Tooltip } from "chart.js";
import "chart.js/auto";
import { useRef } from "react";
import { Line } from "react-chartjs-2";

import { Lang } from "@/i18n-config";

import { getDatasets, getLabels } from "../data/chart-data";
import { getChartOptions } from "../data/chart-options";
import {
  ForecastCategory,
  ForecastChartData,
  ForecastPeriod,
} from "../services/financial-forecast-chart";

ChartJS.register(Tooltip, Legend);

type Props = {
  lang: Lang;
  data: ForecastChartData;
  period: ForecastPeriod;
  category: ForecastCategory;
};

export const ClientLineChart = ({ lang, data, period, category }: Props) => {
  const isEPS = category === "eps";
  const labels = getLabels(data);
  const datasets = getDatasets(labels, data);
  const options = getChartOptions({
    lang,
    category,
    period,
    numberFormatOptions: { maximumFractionDigits: isEPS ? 3 : 2 },
  });

  const ref = useRef();

  return (
    <div className="h-[300px]">
      <Line
        ref={ref}
        options={options}
        data={{
          labels,
          datasets,
        }}
      />
    </div>
  );
};
